import { map } from 'rxjs/operators';

export function some(value: boolean) {
  return map<boolean[] | Record<string | number | symbol, boolean>, boolean>(listOrMap => {
    const list = Array.isArray(listOrMap) ? listOrMap : Object.values(listOrMap);
    return list.some(v => v === value);
  });
}
